// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","LivesNumber":"LivesNumber_LivesNumber__3BlZE","LivesNumberText":"LivesNumber_LivesNumberText__2wNLh","LivesNumberIcon":"LivesNumber_LivesNumberIcon__Yj2hz"};